import { useRef, useState, type ReactElement } from "react";
import {
  Text,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  LogoutIcon,
} from "@citibox-panel/ui";

// Interactive demo for the menu family (IconButton anchor + Menu + MenuItem +
// ListItemIcon + Divider), mirroring how the shell's user menu wires them.
export function MenuDemo(): ReactElement {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  return (
    <>
      <Text variant="body2" color="secondary" gutterBottom>
        Pulsa el botón para abrir el menú (IconButton + Menu + MenuItem +
        ListItemIcon + Divider).
      </Text>
      <IconButton
        ref={anchorRef}
        aria-label="abrir menú"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => {
          setOpen((v) => !v);
        }}
      >
        <LogoutIcon />
      </IconButton>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          role="menuitem"
          onClick={() => {
            setOpen(false);
          }}
        >
          Opción uno
        </MenuItem>
        <Divider />
        <MenuItem
          role="menuitem"
          onClick={() => {
            setOpen(false);
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          Opción con icono
        </MenuItem>
      </Menu>
    </>
  );
}
